<template>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-card>
        <h3 class="card-title d-flex">
          Music List of {{ Name }}
          <a href="" target="_blank" class="ml-2">
            <vs-icon icon="info" size="small" />
          </a>
          <vs-button class="ml-auto" type="filled" icon="add_circle" size="small" @click="addNewPost">Add New Music</vs-button>
        </h3>
        <p class="card-subtitle">List of Music with Different Categories.</p>
        <vs-row>
          <vs-col vs-lg="3" vs-xs="12">
            <vs-select :color="colorx" label="Sorting Type" v-model="search.sort" icon="arrow_downward" @change="searchData()">
              <vs-select-item value text="Select Sorting" disabled />
              <vs-select-item value="ASC" text="Ascending" />
              <vs-select-item value="DESC" text="Descending" />
            </vs-select>
          </vs-col>

          <vs-col vs-lg="3" vs-xs="12">
            <vs-select :color="colorx" label="Filter Using Music Category" v-model="search.category" @change="searchData()" icon="arrow_downward">
              <!-- <vs-select-item value text="Choose Category" disabled /> -->
              <vs-select-item value="" text="All" />
              <vs-select-item value="bhajans" text="Bhajans" />
              <vs-select-item value="shlokas" text="Shlokas" />
              <vs-select-item value="mantras" text="Mantras" />
            </vs-select>
          </vs-col>

          <vs-col vs-lg="3" vs-xs="12">
            <vs-select :color="colorx" label="Filter Using Music Language" icon="arrow_downward" @change="searchData()" v-model="search.language">
              <vs-select-item value text="Choose Language" disabled />
              <vs-select-item :value="item.culture" :text="item.culture" v-for="(item, index) in languages" :key="index" />
            </vs-select>
          </vs-col>

          <vs-col vs-lg="3" vs-xs="12">
            <vs-button color="warning" type="filled" class="searchBtn" @click="resetData()">Reset</vs-button>
            <!-- <vs-button color="primary" type="filled" class="searchBtn" @click="searchData()">Search</vs-button> -->
            <vs-button color="success" type="filled" class="searchBtn" icon="sort" @click="sortPositions()">Sort</vs-button>
          </vs-col>
        </vs-row>
        <br />
        <table class="table" style="text-align: center">
          <tr>
            <th>#</th>
            <th></th>
            <th>Feature Image</th>
            <th>Title</th>
            <th>Category</th>
            <th>Author</th>
            <th @click="sortBy('plays')" style="cursor: pointer; text-align: center">
              Play Counts
              <span v-if="sortByField === 'plays'">{{ sortDirection === "asc" ? "▲" : "▼" }}</span>
            </th>
            <th>Language</th>
            <th @click="sortBy('position')" style="cursor: pointer; text-align: center">
              Position
              <span v-if="sortByField === 'position'">{{ sortDirection === "asc" ? "▲" : "▼" }}</span>
            </th>
            <th></th>
          </tr>
          <tr v-for="(item, index) in all" :key="item._id">
            <td class="td">{{ index + 1 }}</td>
            <td class="td">
              <img v-if="item.god.image == '' || item.god.image == null" src="../../../assets/images/No-image.png" height="50px" width="75px" />
              <img v-else :src="item.god.image" height="50px" width="75px" />
            </td>
            <td class="td">
              <img v-if="item.featureImage == '' || item.featureImage == null" src="../../../assets/images/No-image.png" height="50px" width="75px" />
              <img v-else :src="item.featureImage" height="50px" width="75px" />
            </td>
            <td class="td">{{ item.title }}</td>
            <td class="td">{{ item.category }}</td>
            <td class="td">{{ item.author }}</td>
            <td class="td text-center" style="width: 200px">
              <div style="display: flex; align-items: center; justify-content: center; gap: 0.5rem">
                <div style="display: flex; align-items: center; flex-direction: column; gap: 0.2rem; font-weight: bold;">
                  Total <span>{{ getTotalPlays(item.plays) }}</span>
                </div>
                <div style="display: flex; align-items: center; flex-direction: column; gap: 0.2rem; font-weight: bold;">
                  Recent (24h) <span>{{ getTotalPlays(item.recentPlays) }}</span>
                </div>
              </div>
            </td>
            <td class="td text-center">
              {{ item.language }}
              <div class="d-flex" v-if="search.language == 'EN' && item.languageCount">
                <div class="progress-bar-container mt-3">
                  <div
                    class="progress-bar p-2"
                    :style="{
                      color: item.languageCount - item.missingLanguages.length === item.languageCount ? 'white' : 'black',
                      backgroundColor: item.missingLanguages.length > 0 ? 'red' : item.missingLanguages.length > 1 ? '#06b800' : '',
                      width: ((item.languageCount - item.missingLanguages.length) / item.languageCount) * 100 + '%',
                    }"
                  >
                    <div class="absoluteText">{{ item.languageCount - item.missingLanguages.length }}/{{ item.languageCount }}</div>
                  </div>
                </div>
                <div class="text-center mt-2 d-flex align-items-center" style="font-weight: 800">
                  <div style="width: 20px; height: 20px; margin-left: 5px" v-popover:tooltip="item.tooltipContent">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <circle cx="12" cy="12" r="10"></circle>
                      <line x1="12" y1="16" x2="12" y2="12"></line>
                      <line x1="12" y1="8" x2="12" y2="8"></line>
                    </svg>
                  </div>
                </div>
              </div>
            </td>
            <td class="td">
              <!-- add up and down arrows from react-icons -->
              <div style="display: flex; align-items: center; flex-direction: column; justify-content: center; gap: 0.5rem">
                <vs-button icon="arrow_upward" size="small" @click="updatePosition(item, search.sort === 'ASC' ? 'up' : 'down')"></vs-button>
                {{ item.position }}
                <vs-button icon="arrow_downward" size="small" @click="updatePosition(item, search.sort === 'ASC' ? 'down' : 'up')"></vs-button>
              </div>
            </td>
            <td class="td">
              <vs-button class="mr15 mb10" size="small" color="warning" @click="editingItem(item, 'edit')">Edit</vs-button>
              <vs-button
                class="mr15 mb10"
                size="small"
                color="danger"
                @click="
                  deletePostPopup = true;
                  itemToDelete = item;
                "
                >Delete</vs-button
              >
              <!-- <vs-button class="mr15 mb10" size="small" color="primary"
                @click="editingItem(item, 'clone')">Duplicate</vs-button> -->
            </td>
          </tr>
        </table>

        <!-- Code -->
        <vs-popup :title="isNew ? 'Add New Music' : clone ? 'Duplicate Music' : 'Edit Music'" :active.sync="defaultalert">
          <vs-row>
            <vs-col vs-lg="3" vs-xs="6">
              <label for="Bhajans">Category of Music :</label>
            </vs-col>
            <vs-col vs-lg="2" vs-xs="6">
              <input class="mr5" type="radio" id="bhajans" value="bhajans" v-model="category" />
              <label for="Bhajans">Bhajans</label>
            </vs-col>
            <vs-col vs-lg="2" vs-xs="6">
              <input class="mr-1" type="radio" id="mantras" value="mantras" v-model="category" />
              <label for="Mantras">Mantras</label>
            </vs-col>
            <vs-col vs-lg="2" vs-xs="6">
              <input class="mr5" type="radio" id="shlokas" value="shlokas" v-model="category" />
              <label for="Shlokas">Shlokas</label>
            </vs-col>

            <vs-row>
              <vs-col vs-lg="6" vs-xs="6">
                <vs-select
                  :color="colorx"
                  label="Language Filter"
                  @change="fileterusingLanguage($event, post)"
                  v-model="musicLanguage"
                  icon="arrow_downward"
                  :disabled="isNew"
                >
                  <vs-select-item value text="All Languages" />
                  <vs-select-item :key="index" :value="item.culture" :text="item.culture" v-for="(item, index) in languages" />
                </vs-select>
              </vs-col>
              <vs-col vs-lg="6" vs-xs="6">
                <vs-select :color="colorx" label="God Categories" v-model="godId" icon="arrow_downward">
                  <vs-select-item value text="Choose God" disabled />
                  <vs-select-item :value="item._id" :text="item.name" v-for="(item, index) in godList" :key="index" />
                </vs-select>
              </vs-col>
            </vs-row>

            <vs-col vs-lg="12" vs-xs="12" class="mt20">
              <vs-input label="Music Title (Keep it Simple and short)" v-model="post.title" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12" class="mt20">
              <vs-input label="Music Author Name (Keep it Simple and short)" v-model="post.author" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12" v-if="!isNew">
              <p class="mt-2" style="font-size: 0.85rem">Current Position: {{ post.position }}</p>
            </vs-col>
            <vs-col vs-lg="6" vs-xs="6" class="mt-4">
              <vs-checkbox v-model="post.moveTop" @change="post.moveBottom = false">Move to Top</vs-checkbox>
            </vs-col>
            <vs-col vs-lg="6" vs-xs="6" class="mt-4">
              <vs-checkbox v-model="post.moveBottom" @change="post.moveTop = false">Move to Bottom</vs-checkbox>
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12" class="mb15 mt20">
              <div>
                <vs-col vs-lg="12" vs-xs="12" v-if="displayName == ''">
                  <div class="upload-btn-wrapper vs-input-primary">
                    <label class="vs-input--label">Music File</label>
                    <div class="btn"><vs-icon icon="cloud_upload" class="icon-medium"></vs-icon>Upload a file</div>
                    <input type="file" ref="fileInput" id="musicUpload" @change="uploadMusic($event)" />
                  </div>
                </vs-col>

                <vs-col vs-lg="11" vs-xs="11" v-if="displayName">
                  <div class="upload-btn-wrapper vs-input-primary">
                    <b>Music File :</b>
                    <div class="btn" @click="downloadFile(displayName)">
                      <vs-icon icon="cloud_download" class="icon-medium"></vs-icon>Download file
                    </div>
                    <b>File Name : {{ fileName }}</b>
                  </div>
                </vs-col>
                <vs-col vs-lg="1" vs-xs="1" v-if="displayName">
                  <vs-button color="danger" title="Delete File" type="flat" icon="clear" class="closeBtn" @click="deleteFile()"></vs-button>
                </vs-col>
              </div>
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12" class="mb15 mt20">
              <div>
                <vs-col vs-lg="12" vs-xs="12" v-if="featureImage == '' || !featureImage">
                  <div class="upload-btn-wrapper vs-input-primary">
                    <label class="vs-input--label">Feature Image Upload (Try to use square image)</label>
                    <div class="btn"><vs-icon icon="cloud_upload" class="icon-medium"></vs-icon>Upload a File</div>
                    <input type="file" ref="fileInput" @change="uploadImage($event)" />
                  </div>
                </vs-col>
                <vs-col v-if="featureImage">
                  <div>Feature Image</div>
                  <vs-button color="danger" type="flat" icon="clear" class="closeBtn" @click="deleteFeatureImage()"></vs-button>
                  <img :src="featureImage" class="imgUp" height="100px" width="150px" />
                </vs-col>
              </div>
            </vs-col>
            <vs-col vs-lg="9" vs-xs="12" class="mt20">
              <vs-button icon="save" @click="btnAddPost">{{ isNew ? "Save English" : "Update one" }}</vs-button>
              <vs-button icon="save" @click="createAndTranslate" class="ml-3" v-if="isNew">Create and Translate</vs-button>
              <vs-button icon="save" @click="updateAndTranslate" class="ml-3" v-if="!showLoader && !isNew && !clone && post.language === 'EN'"
                >Update all</vs-button
              >
              <vs-checkbox v-model="post.translate" class="mt-2" v-if="!isNew && !clone && post.language === 'EN'"> Update translations </vs-checkbox>
            </vs-col>
          </vs-row>
        </vs-popup>

        <vs-popup title="Delete Music" :active.sync="deletePostPopup">
          <p>Are you sure you want to delete Music ?</p>
          <div>
            <vs-button class="mr15" @click="deletePost">Delete Music</vs-button>
            <vs-button @click="deletePostPopup = false">Cancel</vs-button>
          </div>
        </vs-popup>

        <vs-popup title="View Details" :active.sync="viewDetails">
          <div v-html="details"></div>
        </vs-popup>
        <!-- Code -->
      </vs-card>
    </vs-col>
    <div v-if="showLoader" class="loader-container">
      <!-- show text that it is working in background. -->
      <div class="loader"></div>
      <vs-col vs-lg="12" vs-xs="1">
        <p class="loader-text">Translations are in progress.</p>
      </vs-col>
    </div>
    <tooltip :width="300" :pointer="true"> </tooltip>
  </vs-row>
</template>

<script>
// import uploader from "../common/uploader.vue";
import api from "@/rest.js";
// import backend from "@/restbackend.js";
import { API } from "@/common/constants";
import Vue from "vue";
import VPopover from "vue-js-popover";

Vue.use(VPopover, { tooltip: true });

export default {
  name: "Post",
  components: {},
  data: () => ({
    displayName: "",
    featureImage: "",
    fileName: "",
    sorting: 1,
    title: "Post",
    colorx: "#0D2144",
    defaultalert: false,
    deletePostPopup: false,
    viewDetails: false,
    Name: "",
    details: "",
    isNew: true,
    clone: false,
    search: {
      sort: "ASC",
      language: "EN",
      category: "",
    },
    category: "",
    post: {
      name: "",
      description: "",
      status: true,
      language: "",
      position: "",
      image: "",
      ref: "",
      moveTop: false,
      moveBottom: false,
      categoryObject: {},
      count: {
        facebook: 0,
        whatsapp: 0,
        instagram: 0,
      },
      tags: [],
    },
    tags: [],
    itemToDelete: "",
    itemToUpdate: "",
    all: [],
    languages: [],
    postLanguage: "",
    musicLanguage: "",
    postLanguages: [],
    godList: [],
    GodId2: "",
    godId: "",
    postCategories: [
      { name: "Bhajans", value: "bhajans" },
      { name: "Shlokas", value: "shlokas" },
      { name: "Mantras", value: "mantras" },
    ],
    routeCategoryGuid: "",
    routeCatLanguage: "",
    routeTagLanguage: "",
    routeCategoryName: "",
    routeTagName: "",
    showLoader: false,
    sortByField: "position",
    sortDirection: "asc",
  }),
  computed: {
    sortedData() {
      return this.all.sort((a, b) => {
        if (this.sortDirection === "asc") {
          return a[this.sortByField] - b[this.sortByField];
        } else {
          return b[this.sortByField] - a[this.sortByField];
        }
      });
    },
  },
  watch: {
    "post.moveTop"(newValue) {
      if (newValue) {
        this.post.moveBottom = false;
      }
    },
    "post.moveBottom"(newValue) {
      if (newValue) {
        this.post.moveTop = false;
      }
    },
  },
  methods: {
    sortBy(field) {
      this.sortByField = field;
      this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
      this.all = this.sortedData;
    },

    getTotalPlays(plays) {
      if (plays >= 1000000) {
        return (plays / 1000000).toFixed(1) + "M";
      } else if (plays >= 1000) {
        return (plays / 1000).toFixed(1) + "K";
      } else {
        return plays || 0;
      }
    },

    sortPositions() {
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };

      if (JSON.parse(localStorage.user).token) {
        headers["x-master-token"] = JSON.parse(localStorage.user).token;
      }
      const godId = this.$data.GodId2 !== "" ? this.$data.GodId2 : this.$data.routeCategoryGuid;

      this.$vs.loading();
      api
        .put(`${API.MUSIC_SORT_POSITION}?language=${this.$data.search.language}&god=${godId}`, {}, { headers })
        .then((r) => {
          if (r.status === 200) {
            this.$vs.notify({
              text: "Sorted Successfully",
              color: "success",
              position: "top-right",
            });
            this.fetchAllPost();
          } else {
            this.$vs.notify({
              title: "Error",
              text: r.data.error,
              color: "danger",
              position: "top-right",
            });
          }
          this.$vs.loading.close();
        })
        .catch(() => {
          this.$vs.notify({
            text: "Error Deleting",
            color: "danger",
            position: "top-right",
          });
          this.$vs.loading.close();
        });
    },

    updatePosition(item, type) {
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };

      if (JSON.parse(localStorage.user).token) {
        headers["x-master-token"] = JSON.parse(localStorage.user).token;
      }

      this.$vs.loading();
      api
        .put(`${API.MUSIC_UPDATE_POSITION}/${item._id}?direction=${type}&god=${item.god._id}`, {}, { headers })
        .then((r) => {
          this.$vs.loading.close();
          if (r.status === 200) {
            this.$vs.notify({
              text: "Position Updated Successfully",
              color: "success",
              position: "top-right",
            });
            this.fetchAllPost();
          }
        })
        .catch((e) => {
          this.$vs.notify({
            text: e.response.data.error,
            color: "danger",
            position: "top-right",
          });
          this.$vs.loading.close();
        });
    },

    async fetchAllPost() {
      this.$vs.loading();

      let id;

      if (this.$data.GodId2 !== "") {
        id = this.$data.GodId2;
      } else {
        id = this.$data.routeCategoryGuid;
      }

      let query = {
        god: id,
        language: this.$data.search.language ? this.$data.search.language : "EN",
        sort: this.$data.search.sort,
      };

      query["position"] = this.$data.sorting;

      const res = await api.get(API.GET_MUSIC, { params: query });
      try {
        if (res.status === 200) {
          for (const item of res.data) {
            item.tooltipContent =
              item.missingLanguages.length > 0 ? "Missing Languages: " + item.missingLanguages.join(", ") : "All Languages are translated";
          }
          this.$data.all = res.data;
          this.$data.Name = res.data[0].god.name;
        }
        this.$vs.loading.close();
      } catch (error) {
        // this.$vs.notify({
        //   title: "Error",
        //   text: res.data.error,
        //   color: "danger",
        //   position: "top-right",
        // });
        this.$vs.loading.close();
        throw error;
      }
    },
    // fileterusingSort(event) {
    //   this.$data.sorting = event;
    //   this.fetchAllPost(event, "position");
    // },
    addNewPost() {
      this.$data.defaultalert = true;
      this.$data.isNew = true;
      this.$data.category = "";
      this.$data.displayName = "";
      this.$data.featureImage = "";
      // this.$data.language = 0;
      this.$data.musicLanguage = "EN";

      (this.$data.post = {
        title: "",
        author: "",
        link: "",
        name: "",
        description: "",
        status: true,
        language: "EN",
        position: "",
        image: "",
        categoryObject: {},
        count: {
          facebook: 0,
          whatsapp: 0,
          instagram: 0,
        },
        tags: { list: [] },
        moveBottom: true,
        moveTop: false,
        translate: false,
      }),
        (this.$data.postLanguages = this.$data.languages);
    },
    editingItem(i, data) {
      this.$data.post = Object.assign({}, i);
      this.$data.postLanguages = this.$data.languages;
      this.$data.category = i.category;
      this.$data.musicLanguage = i.language;
      this.$data.defaultalert = true;
      this.$data.isNew = false;
      this.$data.displayName = i.link;
      this.$data.featureImage = i.featureImage;
      var name = i.link.split("-");
      this.$data.fileName = name[name.length - 1];
      this.$data.clone = data == "clone" ? true : false;
    },
    uploadMusic(data) {
      // if (!this.$data.musicLanguage) {
      //   this.$vs.notify({
      //     text: "Language Culture Require",
      //     color: "warning",
      //     position: "top-right",
      //   });
      //   document.getElementById("musicUpload").value = "";
      //   return;
      // }
      if (
        data.target.files[0].type == "audio/mpeg" ||
        data.target.files[0].type == "audio/x-m4a" ||
        data.target.files[0].type == "audio/x-ms-wma" ||
        data.target.files[0].type == "audio/wav" ||
        data.target.files[0].type == "audio/vnd.dlna.adts" ||
        data.target.files[0].type == "video/mp4" ||
        data.target.files[0].type == "audio/flac"
      ) {
        let formdata = new FormData();
        this.$data.fileName = data.target.files[0].name;
        formdata.append("file", data.target.files[0]);
        formdata.append("god", this.$route.query.catName);
        formdata.append("category", this.$data.category);
        this.$vs.loading();
        api
          .post(API.UPLOAD_MUSIC, formdata, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            if (response.data.error != null) {
              this.$vs.loading.close();
              this.$vs.notify({
                title: "Uploading Error",
                text: response.data.error.message,
                color: "danger",
                position: "top-right",
              });
            } else {
              const data = response;
              this.$data.post.link = response.data.files[0].url;

              this.$data.displayName = response.data.files[0].url;
              if (response) {
                this.$vs.notify({
                  text: "File Uploaded",
                  color: "success",
                  position: "top-right",
                });
                this.$vs.loading.close();
              } else {
                this.$vs.loading.close();
                this.$vs.notify({
                  text: "File Uploading Failed",
                  color: "danger",
                  position: "top-right",
                });
              }
              this.$refs.fileInput.value = null;
              this.$emit("input", data);
            }
          })
          .catch(() => {});
        this.$vs.loading.close();
      } else {
        this.$vs.notify({
          title: "Uploading Error",
          text: "Only music file formats should be supported",
          color: "danger",
          position: "top-right",
        });
        return;
      }
    },
    deleteFile() {
      this.$data.displayName = "";
    },
    deleteFeatureImage() {
      this.$data.featureImage = "";
    },
    downloadFile(file) {
      window.open(file, "_blank");
    },
    btnAddPost() {
      this.$data.post.category = this.$data.category;
      this.$data.post.god = this.$data.routeCategoryGuid;
      this.$data.post.language = this.$data.musicLanguage;

      if (this.$data.featureImage) {
        this.$data.post.featureImage = this.$data.featureImage;
      }

      let data = this.$data.post;
      let fieldName = "";

      if (data.link == "") {
        fieldName = "Music File";
      }
      if (data.featureImage == null || data.featureImage == "") {
        fieldName = "Feature Image";
      }
      if (data.position == "") {
        fieldName = "Music Position";
      }
      if (data.author == "") {
        fieldName = "Music Author Name";
      }
      if (data.title == "") {
        fieldName = "Music Title";
      }
      if (data.language == "") {
        fieldName = "Language is";
      }
      if (data.category == "" || this.$data.category == "") {
        fieldName = "Category of Music is";
      }
      if (
        data.title == "" ||
        data.author == "" ||
        data.link == "" ||
        this.$data.category == "" ||
        data.featureImage == "" ||
        data.featureImage == null
      ) {
        this.$vs.notify({
          text: fieldName + " Require",
          color: "warning",
          position: "top-right",
        });
        return;
      }

      if (this.$data.category != "") {
        if (!this.$data.isNew && !this.$data.clone) {
          if (this.$data.post.link == "") {
            this.$vs.notify({
              text: "Music File Require",
              color: "warning",
              position: "top-right",
            });
            return;
          }
          if (this.$data.featureImage == "") {
            this.$vs.notify({
              text: "Feature Image Require",
              color: "warning",
              position: "top-right",
            });
            return;
          }
          this.btnUpdateMusic();
        } else if (this.$data.clone) {
          data = {
            god: this.$data.godId ? this.$data.godId : this.$data.post.god,
            title: this.$data.post.title,
            author: this.$data.post.author,
            link: this.$data.post.link,
            category: this.$data.post.category,
            language: this.$data.post.language,
            position: this.$data.post.position,
            featureImage: this.$data.post.featureImage,
          };
          this.addMusicRecord(data);
        } else {
          if (this.$data.post.link == "") {
            this.$vs.notify({
              text: "Music File Require",
              color: "warning",
              position: "top-right",
            });
            return;
          }
          this.addMusicRecord(data);
        }
      }
    },

    addMusicRecord(data) {
      this.$vs.loading();
      api
        .post(API.INSERT_MUSIC, data)
        .then((r) => {
          this.$vs.loading.close();
          if (r.status === 200) {
            this.$vs.notify({
              text: "Saved Successfully",
              color: "success",
              position: "top-right",
            });
            this.$data.defaultalert = false;
            this.fetchAllPost();
          } else {
            this.$vs.notify({
              title: "Error",
              text: r.data.error,
              color: "danger",
              position: "top-right",
            });
          }
          this.$data.category = "";
          this.$data.musicLanguage = "";
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },

    async createAndTranslate() {
      this.$data.post.category = this.$data.category;
      this.$data.post.god = this.$data.routeCategoryGuid;
      this.$data.post.language = this.$data.musicLanguage;

      if (this.$data.featureImage) {
        this.$data.post.featureImage = this.$data.featureImage;
      }

      let data = this.$data.post;

      this.$data.showLoader = true;
      this.$data.defaultalert = false;

      const r = await api.post(API.C_AND_T_MUSIC, data);
      try {
        if (r.status == 200) {
          this.$vs.notify({
            text: "Saved Successfully",
            color: "success",
            position: "top-right",
          });
          this.$data.postLanguages = this.$data.languages;
          this.$data.postLanguage = "";
          this.$data.post.title = "";
          this.$data.post.description = "";
          this.fetchAllPost();
          this.$data.defaultalert = false;
          this.$data.showLoader = false;
        }
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: r.data.error,
          color: "danger",
          position: "top-right",
        });
        this.$data.showLoader = false;
        throw error;
      }
    },

    async updateAndTranslate() {
      this.$data.post.category = this.$data.category;
      this.$data.post.god = this.$data.routeCategoryGuid;
      this.$data.post.language = this.$data.musicLanguage;
      this.$data.post.translate = this.$data.post.translate;

      if (this.$data.featureImage) {
        this.$data.post.featureImage = this.$data.featureImage;
      }

      let data = this.$data.post;
      let id = this.$data.post._id;

      this.$data.showLoader = true;
      this.$data.defaultalert = false;

      try {
        const r = await api.put(`${API.U_AND_T_MUSIC}/${id}`, data);
        this.$vs.loading.close();
        if (r.status == 200) {
          this.$vs.notify({
            text: "Updated Successfully",
            color: "success",
            position: "top-right",
          });
          this.$data.isNew = true;
          this.$data.itemToUpdate = "";
          this.$data.defaultalert = false;
          this.$data.post = {
            title: "",
            author: "",
            link: "",
            name: "",
            image: "",
            language: "",
            featureImage: "",
          };
          this.fetchAllPost();
          this.$data.showLoader = false;
        }
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: "Error in updating",
          color: "danger",
          position: "top-right",
        });
        this.$data.showLoader = false;
        throw error;
      }
    },

    btnUpdateMusic() {
      this.$data.post.god = this.godId;
      let data = this.$data.post;
      let id = this.$data.post._id;

      this.$vs.loading();
      api
        .put(`${API.UPDATE_MUSIC}/?id=${id}`, data)
        .then((r) => {
          this.$vs.loading.close();
          if (r.status == 200) {
            this.$vs.notify({
              text: "Updated Successfully",
              color: "success",
              position: "top-right",
            });
            this.$data.isNew = true;
            this.$data.itemToUpdate = "";
            this.$data.defaultalert = false;
            (this.$data.post = {
              title: "",
              author: "",
              link: "",
              name: "",
              image: "",
              language: "",
              featureImage: "",
            }),
              this.fetchAllPost();
          } else {
            this.$vs.notify({
              title: "Error",
              text: r.data.error,
              color: "danger",
              position: "top-right",
            });
          }
          this.$data.category = "";
          this.$data.musicLanguage = "";
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },
    uploadImage(data) {
      const imageType = ["image/jpeg", "image/jpg", "image/webp"];
      var isValid = false;
      isValid = imageType.indexOf(data.target.files[0].type) > -1;

      if (!isValid) {
        this.$vs.notify({
          title: "Uploading Error",
          text: "Only JPEG,JPG,WEBP Image files formats should be supported",
          color: "danger",
          position: "top-right",
        });
        this.$refs.fileInput.value = null;
        return;
      }
      if (data.target.files[0].size > 500000) {
        this.$vs.notify({
          title: "Uploading Error",
          text: "File size should be less than 500kb",
          color: "danger",
          position: "top-right",
        });
        return;
      }

      let formdata = new FormData();
      this.$data.fileName = data.target.files[0].name;
      formdata.append("file", data.target.files[0]);
      this.$vs.loading();
      api
        .post(API.UPLOAD_IMAGE, formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.error != null) {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Uploading Error",
              text: response.data.error.message,
              color: "danger",
              position: "top-right",
            });
          } else {
            const data = response;
            this.$data.featureImage = response.data.files[0].url;

            if (response) {
              this.$vs.notify({
                text: "File Uploaded",
                color: "success",
                position: "top-right",
              });
              this.$vs.loading.close();
            } else {
              this.$vs.loading.close();
              this.$vs.notify({
                text: "File Uploading Failed",
                color: "danger",
                position: "top-right",
              });
            }
            this.$refs.fileInput.value = null;
            this.$emit("input", data);
          }
        })
        .catch(() => {});
      this.$vs.loading.close();
    },
    deletePost() {
      let id = this.$data.itemToDelete._id;
      api
        .delete(`${API.DELETE_MUSIC}/${id}`)
        .then((r) => {
          if (r.status == 200) {
            this.$vs.notify({
              text: "Deleted Successfully",
              color: "success",
              position: "top-right",
            });
          } else {
            this.$vs.notify({
              text: "Already Deleted",
              color: "danger",
              position: "top-right",
            });
          }
          this.$data.deletePostPopup = false;
          this.fetchAllPost();
          this.$vs.loading.close();
        })
        .catch(() => {});
    },
    fetchAllLanguages() {
      this.$vs.loading();
      api
        .get(API.GET_LANG, {})
        .then((r) => {
          this.$vs.loading.close();
          this.$data.languages = r.data;
        })
        .catch(() => {});
    },
    searchData() {
      this.$vs.loading();

      api
        .get(
          `${API.SEARCH_MUSIC}?sort=${this.$data.search.sort}&language=${this.$data.search.language}&category=${this.$data.search.category}&god=${this.$data.routeCategoryGuid}`
        )
        .then((r) => {
          if (r.data[0].language === "EN" && r.data[0].missingLanguages) {
            for (const item of r.data) {
              item.tooltipContent =
                item.missingLanguages.length > 0 ? "Missing Languages: " + item.missingLanguages.join(", ") : "All Languages are translated";
            }
          }

          this.$data.all = r.data;
          this.$data.Name = r.data[0].god.name;
          this.$data.GodId2 = r.data[0].god._id;
          this.$vs.loading.close();
        })
        .catch(() => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Error",
            text: "God Category Not Found",
            color: "danger",
            position: "top-right",
          });
        });
    },
    resetData() {
      if (this.$route.params.catId != null) {
        this.$data.search = {
          sort: "ASC",
          language: "EN",
          category: "",
        };
      } else {
        this.$data.search = {
          sort: "ASC",
          language: "EN",
          category: "",
        };
      }
      this.fetchAllPost();
    },
    fetchAllTags(lang) {
      this.$vs.loading();
      api
        .post(API.GET_TAG, {
          language: lang,
        })
        .then((r) => {
          this.$vs.loading.close();
          this.$data.tags = [];
          r.data.data.forEach((element) => {
            this.$data.tags.push(element.name);
          });
        })
        .catch(() => {});
    },
    fetchActiveCategoriesByLanguage(lang, next) {
      this.$vs.loading();
      this.$data.postCategories = [];
      api
        .post(API.GET_ACTIVE_CATEGORY_BY_LANGUAGE, { language: lang })
        .then((r) => {
          this.$vs.loading.close();
          if (r.data.status) {
            this.$data.postCategories = r.data.data;
            if (next != null) {
              next();
            }
          } else {
            this.$vs.notify({
              title: "Error",
              text: "Choose Other Language No Category Found",
              color: "danger",
              position: "top-right",
            });
          }
        })
        .catch(() => {});
    },
    viewDescription(i) {
      this.$data.viewDetails = true;
      this.$data.details = i.description;
    },
    fetchAllPostsByCatgeoryGuid(guid, lang) {
      this.$vs.loading();
      api
        .post(API.GET_ALL_POST_BY_CAT_GUID, {
          language: lang,
          size: "100",
          offset: "0",
          categoryGuid: guid,
        })
        .then((r) => {
          this.$vs.loading.close();
          if (!r.data.status) {
            this.$vs.notify({
              title: "Error",
              text: r.data.error + " for this Category",
              color: "danger",
              position: "top-right",
            });
          } else {
            this.$data.all = r.data.data.rows;
          }
        })
        .catch(() => {});
    },
    fetchAllPostsByTagName(tag, lang) {
      this.$vs.loading();
      api
        .post(API.GET_ALL_POST_BY_TAG_NAME, {
          language: lang,
          size: "100",
          offset: "0",
          tagName: tag,
        })
        .then((r) => {
          this.$vs.loading.close();
          if (!r.data.status) {
            this.$vs.notify({
              title: "Error",
              text: r.data.error + " for this Tag",
              color: "danger",
              position: "top-right",
            });
          } else {
            this.$data.all = r.data.data.rows;
          }
        })
        .catch(() => {});
    },
    fetchAllGodCategory(lang) {
      this.$vs.loading();
      let apiToCall = `${API.GET_GOD}?language=${lang}`;
      // if (lang) {
      //   apiToCall = `${API.GET_GOD}?language=${lang}`;
      // }
      api
        .get(apiToCall)
        .then((r) => {
          this.$vs.loading.close();
          this.$data.godList = r.data;
          if (r.status != 200) {
            this.$vs.notify({
              title: "Error",
              text: r.data.error,
              color: "danger",
              position: "top-right",
            });
          }
        })
        .catch(() => {});
    },
    fileterusingLanguage(event, item) {
      if (event) {
        let headers = {
          "Content-Type": "application/json;charset=utf-8",
        };
        if (JSON.parse(localStorage.user).token) {
          headers["token"] = this.$data.token;
        }
        if (this.isNew) {
          this.fetchAllGodCategory(event);
        } else {
          let id = item.ref || item._id;
          this.$vs.loading();
          api
            .get(`${API.GET_SINGLE_MUSIC}/${id}?language=${event}`, { headers })
            .then((r) => {
              // console.log(r.data)
              this.$data.post = Object.assign({}, r.data);
              this.$data.displayImage = r.data.image;
              this.$data.featureImage = r.data.featureImage;
              this.$data.godId = r.data.god._id;
              this.fetchAllGodCategory(event);
              this.fetchAllPost();
              this.$vs.loading.close();
            })
            .catch(() => {
              this.$vs.loading.close();
            });
        }
      }
    },
  },
  watch: {
    postLanguage() {},
  },
  mounted() {
    this.$data.routeCategoryGuid = this.$route.params.catGuid;
    this.$data.godId = this.$route.params.catGuid;
    this.$data.routeCatLanguage = this.$route.query.catLang;
    this.$data.routeTagLanguage = this.$route.query.tagLang;
    this.$data.routeCategoryName = this.$route.query.catName;
    this.$data.routeTagName = this.$route.params.tagName;
    this.$data.search.language = this.$data.routeCatLanguage;

    this.$data.Name = this.$data.routeCategoryName;

    this.fetchAllPost();
    this.fetchAllLanguages();
    this.fetchAllGodCategory();
  },
};
</script>
<style scoped>
.loader-container {
  background-color: gray;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 1rem;
  padding-right: 1rem;
  padding-left: 1rem;
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
}

.loader {
  border: 2px solid white;
  border-top: 2px solid red;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

.loader-text {
  color: white;
  text-align: center;
  font-size: 1.2rem;
  margin-top: 10px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.mb15 {
  margin-bottom: 15px;
}

.mb10 {
  margin-bottom: 10px;
}

.mr15 {
  margin-right: 15px;
}

.mr5 {
  margin-right: 5px;
}

.td {
  vertical-align: middle;
  text-align: center;
}

.mt20 {
  margin-top: 20px;
}

.searchBtn {
  margin-top: 25px;
  margin-right: 5px;
  width: 30%;
}

.bdr {
  border: 1px solid #f7f7f7;
  padding: 5px;
}

.closeBtn {
  float: right;
  right: 0px;
  top: 0px;
}

.imgUp {
  margin-bottom: 20px;
}

.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
  width: 100%;
  cursor: pointer !important;
}

.btn {
  border: 1px solid rgba(0, 0, 0, 0.2);
  background-color: white;
  padding: 0.4rem;
  border-radius: 0px;
  font-size: 0.85rem;
  width: 100%;
  cursor: pointer;
}

.upload-btn-wrapper input[type="file"] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}

.progress-bar-container {
  width: 100%;
  background-color: #f3f3f3;
  border: 1px rgba(0, 0, 0, 0.068) solid;
  border-radius: 20px;
  overflow: hidden;
  margin-bottom: 5px;
}

.progress-bar {
  height: 10px;
  transition: width 0.3s ease;
}

.absoluteText {
  text-align: start;
}
</style>
